import {
  FilterDisclosure,
  FilterFooter,
  FilterListbox,
  FilterOptionCheckbox,
  FilterPopover,
} from '@vtex/admin-ui'
import { useIntl } from 'react-intl'
import type { SimplifiedPromotion } from 'typings'
import { statusMessages } from '../../Table/Columns'
import { getStatusInfo } from '../../status'
import { usePromotionsFilterMultipleState } from '../useFiltersState'

function filterByStatus(
  promotion: SimplifiedPromotion,
  statuses: string[] | undefined
) {
  if (!statuses || !statuses.length) return true

  const { id } = getStatusInfo(promotion)

  return statuses.includes(id)
}

export function FilterByStatus() {
  const { formatMessage } = useIntl()
  const state = usePromotionsFilterMultipleState({
    id: 'status',
    filterFn: (item) =>
      filterByStatus(
        item,
        state.appliedItems.map((x) => x.id)
      ),
  })

  const options = [
    {
      id: 'running',
      label: formatMessage(statusMessages.running),
    },
    {
      id: 'scheduled',
      label: formatMessage(statusMessages.scheduled),
    },
    {
      id: 'paused',
      label: formatMessage(statusMessages.paused),
    },
    {
      id: 'completed',
      label: formatMessage(statusMessages.completed),
    },
  ]

  return (
    <>
      <FilterDisclosure state={state}>
        {formatMessage(statusMessages.status)}
      </FilterDisclosure>
      <FilterPopover state={state}>
        <FilterListbox>
          {options.map((item) => (
            <FilterOptionCheckbox key={item.id} {...item} value={item.id} />
          ))}
        </FilterListbox>
        <FilterFooter />
      </FilterPopover>
    </>
  )
}
